import { useLocation } from 'react-router';
import { useGetMeQuery } from 'src/shared/api/admin';
import { AdminScope } from 'src/modules/Admin/types';
import { getAdminScope } from 'src/modules/Admin/utils';

export const useIsHeroAdmin = () => {
  const { pathname } = useLocation();
  // Superadmin sessions have no /me membership; asking for it logs them out on 401.
  const { data, isLoading, isError, error } = useGetMeQuery(
    { isCustomError: true },
    { skip: pathname.startsWith('/super') }
  );

  return {
    isHeroAdmin: data !== undefined && getAdminScope(data) === AdminScope.HOLDING,
    isLoading,
    isError,
    error
  };
};
